<template>
  <el-popover
    :width="width"
    v-model="visible"
  >
    <el-input
      @mouseenter.native="hover = true"
      @mouseleave.native="hover = false"
      slot="reference"
      :value="selectedLabel"
      :disabled="disabled"
      :placeholder="placeholder"
      :prefix-icon="icon"
      readonly
    >
      <i
        slot="suffix"
        v-show="clearVisible"
        class="el-icon-circle-close"
        @click="clear"
      ></i>
      <i
        v-show="!clearVisible"
        slot="suffix"
        class=" el-input__icon"
        :class="arrowClass"
      ></i>
    </el-input>
    <section class="yh-tree-container">
      <el-tree
        :highlight-current="highlightCurrent"
        class="yh-tree"
        v-bind="$attrs"
        @node-click="handleNodeClick"
      ></el-tree>
    </section>
  </el-popover>
</template>

<script>
/**
 * 使用示例：可传入参数与 el-tree 雷同
 * @change 当选择改变时触发，接受的数据为 node.data
 * :placeholder 为展示框中数据
 * icon input 中图标
 * disabled 是否可选
 * value input 数据
 * <yh-select-tree
    :data="funcMenuList"
    :props="defaultProps"
    :placeholder="ph"
    @change="handleSelectChange"
    :render-content="renderTreeItem"
  />
 */
export default {
  name: 'YhSelectTree',
  props: {
    clearable: {
      type: Boolean,
      default: true,
    },
    width: {
      type: Number,
      default: 200,
    },
    icon: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '请选择根菜单或上级菜单',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    highlightCurrent: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      hover: false,
      visible: false,
    };
  },
  computed: {
    clearVisible() {
      return this.clearable && this.hover && this.selectedLabel;
    },
    arrowClass() {
      return this.visible ? 'el-icon-arrow-up' : 'el-icon-arrow-down';
    },
    selectedLabel: {
      get() {
        return this.value;
      },
    },
  },
  methods: {
    clear(e) {
      this.$emit('change', Object.create(null));
      e.stopPropagation();
    },
    handleNodeClick(data) {
      if (!data.disabled) {
        this.$emit('change', data);
        this.visible = false;
      }
    },
  },
};
</script>

<style lang="scss">
.yh-tree-container {
  overflow: auto;
  height: 100%;
  max-height: 350px;
}
.yh-tree {
  padding: 6px 0;
}
.el-popover {
  box-sizing: border-box;
}
.el-input.el-input--suffix {
  outline: none;
}
</style>
